module.exports = __webpack_public_path__ + "static/media/11.2e849a06.jpg";